import { render, staticRenderFns } from "./ReporteEstatusBasculas.vue?vue&type=template&id=53420ee0&scoped=true&"
import script from "./ReporteEstatusBasculas.vue?vue&type=script&lang=js&"
export * from "./ReporteEstatusBasculas.vue?vue&type=script&lang=js&"
import style0 from "./ReporteEstatusBasculas.vue?vue&type=style&index=0&id=53420ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53420ee0",
  null
  
)

export default component.exports